import __request__ from "routing/request";
export function list(page = 1, per_page = 50, query, filters, sort = "created_at", order = "desc", requestOptions) {
  return __request__("GET", "/opamp/enrollment-tokens", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createToken(JSONbody, requestOptions) {
  return __request__("POST", "/opamp/enrollment-tokens", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(JSONbody, requestOptions) {
  return __request__("POST", "/opamp/enrollment-tokens/bulk_delete", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(tokenId, requestOptions) {
  return __request__("DELETE", `/opamp/enrollment-tokens/${tokenId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
